import { inject, NgModule } from '@angular/core';
import { Apollo, APOLLO_OPTIONS, provideNamedApollo } from 'apollo-angular';
import { ApolloClientOptions, ApolloLink, concat, InMemoryCache, RequestHandler } from '@apollo/client/core';
import { HttpLink } from 'apollo-angular/http';
import { EnvironmentService, LipoMessageService } from 'FoxxyLib';
import { IClientError, ISortimentierenEnvironment } from 'FoxxyInterfaces';
import { onError } from '@apollo/client/link/error';
import { Store } from '@ngrx/store';
import { LogUsersClientErrorAction } from './store/user/actions';
import { LogLevel } from '@microsoft/signalr';
import { MessageService, ToastMessageOptions } from 'primeng/api';

import { GraphQLService } from './graphql.service';
import { CockpitStore } from './cockpit/store/cockpitStore';

// https://stackoverflow.com/questions/57524580/how-to-use-import-onerror-from-apollo-link-error-in-angular-to-handle-all




/**Errorhandling einfügen ! */
function getLink(store: Store<any>, mess: LipoMessageService<ToastMessageOptions>): ApolloLink | RequestHandler {

  const link = onError(({  graphQLErrors, networkError }) => {

    if (graphQLErrors)
      graphQLErrors.map(({ message, locations, path, extensions }) => {
        const e = `[GraphQL error]: Message: ${message}, Location: ${locations?.toString()}, Path: ${path?.toString()}, Extensions: ${extensions ? JSON.stringify(extensions) : ''}  `;

        store.dispatch(new LogUsersClientErrorAction({ error: <IClientError>{ loglevel: LogLevel.Debug, userid: null, error: e, modul: 'GraphQl Sortimentieren' } }));
      }
      );
    if (networkError) {
      mess.Publish({ severity: 'error', summary: 'Network Error', detail: networkError.message });
      store.dispatch(new LogUsersClientErrorAction({ error: <IClientError>{ loglevel: LogLevel.Error, userid: null, error: networkError, modul: 'GraphQl Sortimentieren' } }));
    }

  });
  return link;
}



const graphqlMiddleware = new ApolloLink((operation, forward) => {
  operation.setContext({
    headers: {
      'Access-Control-Allow-Origin': '*',
    }
  });
  return forward(operation);
})

/**Test Apollo von Roland*/
export function createApolloTest(httpLink: HttpLink): ApolloClientOptions<any> {

  const urlTest = "https://parfesdat02.paragon-systems.de:7150/graphql/";
  const store = inject(Store);
  const lipomessageService = inject(LipoMessageService<ToastMessageOptions>)
  //console.log("createApollo Roland TEST URL:" + urlTest);
  return {
    link: ApolloLink.from([
      getLink(store, lipomessageService),
      graphqlMiddleware,
      httpLink.create({
        uri: (operation) => {
          const opName = operation.operationName
            || operation.query?.definitions?.[0]?.['name']?.value
            || 'query';
          return `${urlTest}?op=${opName}`;
        }
      })
    ]),
    cache: new InMemoryCache(),
    defaultOptions: {
      query: {
        fetchPolicy: 'no-cache',
        errorPolicy: 'all'
      },
      watchQuery: {
        fetchPolicy: 'no-cache',
        errorPolicy: 'all'
      }
    }
  };
}

/**Apollo Sortimentieren Endpunkt
 * _typnames raus  --> https://stackoverflow.com/questions/47211778/cleaning-unwanted-fields-from-graphql-responses/51380645#51380645
*/
export function createApolloSortimentieren(httpLink: HttpLink): ApolloClientOptions<any> {
  const envir = inject(EnvironmentService<ISortimentierenEnvironment>) as EnvironmentService<ISortimentierenEnvironment>;
  const store = inject(Store);
  const lipomessageService = inject(LipoMessageService<ToastMessageOptions>)
  const baseUrl = envir.environment.graphQLUrlSortimentieren;

  return {
    link: ApolloLink.from([
      getLink(store, lipomessageService),
      graphqlMiddleware,
      httpLink.create({
        uri: (operation) => {
          const opName = operation.operationName
            || operation.query?.definitions?.[0]?.['name']?.value
            || 'query';
          return `${baseUrl}?op=${opName}`;
        }
      })
    ]),
    cache: new InMemoryCache(),
    defaultOptions: {
      query: {
        fetchPolicy: 'no-cache',
        errorPolicy: 'all'
      },
      watchQuery: {
        fetchPolicy: 'no-cache',
        errorPolicy: 'all'
      }
    }
  };
}

@NgModule({
  providers: [Apollo, GraphQLService,CockpitStore,
    MessageService, LipoMessageService<ToastMessageOptions>,
    provideNamedApollo(() => {
      const httpLink = inject(HttpLink);
      return {
        default: createApolloSortimentieren(httpLink),
        test: createApolloTest(httpLink)
      }
    }),
  ],
})
export class GraphQLModule { }

